import React from 'react'
import { useLocation } from 'react-router-dom'

import useSubMenu from 'hooks/useSubMenu'
import { hasSubMenuRouting } from 'shared/utils/hasSubMenuRouting'

import PageHeader, { PageHeaderProps } from '.'

type PageHeaderContainerProps = Omit<PageHeaderProps, 'showSubMenuToggle' | 'onOpenSubMenu'>

export default function PageHeaderContainer({
  title,
  leftSlot,
  rightSlot,
}: PageHeaderContainerProps) {
  const { isShowSubMenu, setIsShowSubMenu, setShouldShowToggleIcon } = useSubMenu()
  const { pathname } = useLocation()
  const routeHasSubMenu = hasSubMenuRouting(pathname)

  function openSubMenu() {
    setIsShowSubMenu(true)
    setShouldShowToggleIcon(false)
  }

  return (
    <PageHeader
      title={title}
      leftSlot={leftSlot}
      rightSlot={rightSlot}
      showSubMenuToggle={routeHasSubMenu && !isShowSubMenu}
      onOpenSubMenu={openSubMenu}
    />
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/PageHeader/container.tsx